"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tab.default;
  }
});

var _Tab = _interopRequireDefault(require("./Tab"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Tab/index.js
// module id = 867
// module chunks = 0